var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2390_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4631 80.25H49.0418V57.9583H57.9584V80.25H62.5371C63.1256 74.8911 65.8586 70.4684 70.2946 65.64C70.7984 65.0961 74.004 61.7747 74.3829 61.3021C77.5318 57.3682 79.5055 52.6249 80.0767 47.6185C80.648 42.612 79.7936 37.546 77.6119 33.0039C75.4301 28.4618 72.0099 24.6282 67.7449 21.9447C63.48 19.2612 58.5438 17.8369 53.5049 17.8359C48.466 17.8348 43.5292 19.257 39.2631 21.9386C34.997 24.6203 31.5751 28.4524 29.3915 32.9936C27.2078 37.5348 26.3513 42.6004 26.9204 47.6071C27.4895 52.6138 29.4612 57.3579 32.6083 61.2932C32.9918 61.7702 36.2062 65.0961 36.7011 65.6356C41.1416 70.4684 43.8745 74.8911 44.4631 80.25ZM44.5834 89.1667V93.625H62.4168V89.1667H44.5834ZM25.6533 66.875C21.4544 61.6289 18.8229 55.3033 18.062 48.6269C17.301 41.9505 18.4415 35.195 21.3522 29.1385C24.2628 23.082 28.8252 17.971 34.5136 14.3941C40.2021 10.8172 46.7853 8.92007 53.5049 8.92114C60.2245 8.92222 66.8071 10.8215 72.4944 14.4002C78.1818 17.9789 82.7425 23.0914 85.6512 29.1488C88.5599 35.2063 89.6982 41.9621 88.9351 48.6383C88.172 55.3144 85.5385 61.6391 81.3379 66.8839C78.5738 70.3258 71.3334 75.7917 71.3334 82.4792V93.625C71.3334 95.9899 70.394 98.2578 68.7218 99.93C67.0496 101.602 64.7816 102.542 62.4168 102.542H44.5834C42.2186 102.542 39.9506 101.602 38.2784 99.93C36.6062 98.2578 35.6668 95.9899 35.6668 93.625V82.4792C35.6668 75.7917 28.422 70.3258 25.6533 66.875Z",
    fill: "#242731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2390_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbLine);
export default __webpack_public_path__ + "static/media/lightbulb-line.f719f84a33b354481b06963fde95e444.svg";
export { ForwardRef as ReactComponent };